export interface OriginValidationResult {
  valid: boolean;
  reason?: string;
}

export function validateOrigin(
  origin: string,
  options?: { allowHttpLocalhost?: boolean },
): OriginValidationResult {
  const allowHttpLocalhost = Boolean(options?.allowHttpLocalhost);

  try {
    const parsed = new URL(origin);
    const isLocalhost =
      parsed.hostname === 'localhost' || parsed.hostname === '127.0.0.1';

    if (parsed.protocol === 'https:') {
      return { valid: true };
    }

    if (allowHttpLocalhost && parsed.protocol === 'http:' && isLocalhost) {
      return { valid: true };
    }

    return { valid: false, reason: 'Origin must use HTTPS' };
  } catch {
    return { valid: false, reason: 'Origin is not a valid URL' };
  }
}

export function isFramedByCrossOrigin(windowRef: Window): boolean {
  if (windowRef.top === windowRef.self) return false;
  try {
    return windowRef.top?.location.origin !== windowRef.location.origin;
  } catch {
    return true;
  }
}

